import { useMatchRoute } from "@tanstack/react-router";
import AbandonedCheckoutPromoBanner from "../banners/PromoBanner/AbandonedCheckoutPromoBanner";
import { TopBarPlacement } from "../banners/placements/TopBarPlacement";
import StripeBlockedBanner from "../banners/StripeBlockedBanner";
import SubUserBanner from "../banners/SubUserBanner";
import VerifyEmailBanner from "../banners/VerifyEmailBanner";
import VipWelcomeBanner from "../banners/VipWelcomeBanner";
import useStripeLoadFailed from "@/hooks/useStripeLoadFailed";

import { Stack } from "@mui/material";

export default function Banners() {
  const matchRoute = useMatchRoute();
  // Shown on every page, above everything else, while a Webshare proxy blocks
  // Stripe.js (r-1956) — including the VIP page, which otherwise shows only
  // its own banner.
  const stripeBlockedBanner = useStripeLoadFailed() ? (
    <StripeBlockedBanner />
  ) : null;

  // VIP Banner should be displayed alone in VIP page
  if (matchRoute({ to: "/profile/vip" })) {
    return (
      <>
        {stripeBlockedBanner}
        <VipWelcomeBanner />
      </>
    );
  }

  // The Top bar sits outside the stack: a sticky one sticks only within its
  // parent, and the stack is no taller than its banners.
  return (
    <>
      <Stack direction="column" spacing={1}>
        {stripeBlockedBanner}
        <VerifyEmailBanner />
        <AbandonedCheckoutPromoBanner />
      </Stack>
      <TopBarPlacement />
      {/* SubUserBanner should be always the last one in banners  */}
      <SubUserBanner />
    </>
  );
}
